import { Tab } from 'pages/Shipments/HistoricalPerDiem/components/Tab';
import * as React from 'react';
import { OutstandingFeesBreakdown } from 'services/clients/insights';

const OPTION_MAP: Record<OutstandingFeesBreakdown, { label: string; order: number }> = {
  [OutstandingFeesBreakdown.Terminal]: {
    label: 'By terminal',
    order: 0,
  },
  [OutstandingFeesBreakdown.Port]: {
    label: 'By port',
    order: 1,
  },
  [OutstandingFeesBreakdown.ShippingLine]: {
    label: 'By SSL',
    order: 2,
  },
  [OutstandingFeesBreakdown.Container]: {
    label: 'By container',
    order: 3,
  },
  [OutstandingFeesBreakdown.OceanBOL]: {
    label: 'By ocean BOL',
    order: 4,
  },
};

interface Props {
  value: OutstandingFeesBreakdown;
  onChange: (value: OutstandingFeesBreakdown) => void;
  options: OutstandingFeesBreakdown[];
  disabled?: boolean;
}

export const Tabs: React.FC<Props> = (props) => {
  const { value, onChange, options, disabled } = props;

  const tabs = React.useMemo(
    () =>
      options
        .sort((a, b) => OPTION_MAP[a].order - OPTION_MAP[b].order)
        .map((option) => {
          const { label } = OPTION_MAP[option];
          return (
            <Tab
              key={option}
              onChange={onChange}
              active={value === option}
              label={label}
              disabled={disabled}
              value={option}
            />
          );
        }),
    [onChange, value, options, disabled]
  );

  return <div className="flex">{tabs}</div>;
};
